import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { fullScreen: true }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: () => import('@/views/dashboard/index'),
    name: 'Dashboard',
    meta: { title: 'HOME', icon: 'el-icon-s-home', affix: true }
  },
  // kisae--详情页
  {
    path: '/kisae',
    redirect: '/kisae/kisaeIndex',
    component: () => import('@/views/kisae'),
    name: 'KISAE',
    children: [
      {
        path: 'kisaeIndex',
        component: () => import('@/views/kisae/kisaeIndex'),
        meta: { title: 'KISAEINDEX', noCache: true }
      },
      {
        name: 'kisaeDetail',
        path: 'kisaeDetail',
        component: () => import('@/views/kisae/kisaeDetail'),
        meta: { title: 'DETAIL', noCache: true }
      },
      {
        path: 'kisaeDataIndex',
        component: () => import('@/views/kisae/data/kisaeDataIndex'),
        meta: { title: 'KISAEDATA', noCache: true }
      },
      {
        name: 'kisaeDataDetail',
        path: 'kisaeDataDetail',
        component: () => import('@/views/kisae/data/kisaeDataDetail'),
        meta: { title: 'DETAIL', noCache: true }
      }
    ]
  },
  // 产品
  {
    path: '/product',
    component: () => import('@/views/product'),
    redirect: '/product/productIndex',
    name: 'productOrder',
    hidden: true,
    children: [{
      path: 'productIndex',
      component: () => import('@/views/product/productIndex'),
      meta: { title: '', icon: 'el-icon-s-order', noCache: true }
    }, {
      path: 'productAddEdit',
      component: () => import('@/views/product/productAddEdit'),
      meta: { title: 'SETTING', icon: 'dashboard', noCache: true }
    }, {
      path: 'productDetail',
      component: () => import('@/views/product/productDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }]
  },
  // 全部设备
  {
    name: 'DEVICES',
    path: '/allDevices',
    component: () => import('@/views/allDevices'),
    redirect: '/allDevices/allDeviceIndex',
    children: [{
      path: 'allDeviceIndex',
      component: () => import('@/views/allDevices/allDeviceIndex'),
      meta: { keepAlive: true }
    }, {
      path: 'allDeviceDetail',
      component: () => import('@/views/allDevices/detail/allDeviceDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'allDeviceLithiumDetail',
      component: () => import('@/views/allDevices/detail/allDeviceLithiumDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'socDetailChart',
      component: () => import('@/views/allDevices/detail/socDetailChart'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'allDeviceEveBmsDetail',
      component: () => import('@/views/allDevices/detail/allDeviceEveBmsDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'allDeviceEveF477Detail',
      component: () => import('@/views/allDevices/detail/allDeviceEveF477Detail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'yhubReport',
      component: () => import('@/views/allDevices/report/yhubReport'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'lithiumChartPage',
      component: () => import('@/views/allDevices/report/lithiumChartPage'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'dcdcDetail',
      component: () => import('@/views/dcdc/dcdcDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'acChargeDetail',
      component: () => import('@/views/charge/acChargeDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'inverterDetail',
      component: () => import('@/views/inverter/inverterDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }, {
      path: 'inverterDetailNew',
      component: () => import('@/views/inverter/inverterDetailNew'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    },
    {
      path: 'trionicDetail',
      component: () => import('@/views/trionic/trionicDetail'),
      name: 'trionicDetail',
      meta: { title: 'DETAIL', icon: 'component', affix: true }
    }
    ]
  },
  // trionic主页
  {
    path: '/trionic',
    component: () => import('@/views/trionic/trionicIndex'),
    name: 'trionicDashboard',
    meta: { title: 'trionicIndex', icon: 'dashboard', affix: true }
  },
  // 邮件周报
  {
    path: '/w/yhub',
    component: () => import('@/views/weekReportEmail/weekReportEmail'),
    meta: { title: '', icon: 'dashboard', noCache: true, fullScreen: true }
  },
  // 逆电器详情页
  {
    path: '/inverter',
    component: () => import('@/views/inverter/inverterDetail'),
    meta: { title: 'Inverter', icon: 'dashboard', noCache: true }
  },
  // system详情页
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/system/systemDetail'),
    meta: { title: 'System', icon: 'dashboard', noCache: true }
  },
  {
    name: 'LOCATION',
    path: '/locationMagt',
    component: () => import('@/views/locationManagement'),
    redirect: '/locationMagt/locationMagtIndex',
    children: [
      {
        path: 'locationMagtIndex',
        component: () => import('@/views/locationManagement/locationMagtIndex'),
        meta: { keepAlive: true }
      }, {
        path: 'traceMap',
        component: () => import('@/views/locationManagement/traceMap'),
        meta: { title: 'TRACKREPLAY', icon: 'dashboard', noCache: true }
      }, {
        path: 'electricFence',
        component: () => import('@/views/locationManagement/electricFence'),
        meta: { title: 'GEOFENCING', icon: 'dashboard', noCache: true }
      }]
  },
  // 租赁管理页
  {
    path: '/leaseMagt',
    redirect: '/leaseMagt/leaseMagtIndex',
    name: 'LEASE',
    component: () => import('@/views/leaseManagement'),
    children: [{
      path: 'leaseMagtIndex',
      component: () => import('@/views/leaseManagement/leaseMagtIndex')
    }, {
      name: 'leaseMagtDetail',
      path: 'leaseMagtDetail',
      component: () => import('@/views/leaseManagement/leaseMagtDetail'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true },
      hidden: true
    }]
  },

  {
    path: '/sim',
    component: () => import('@/views/sim'),
    redirect: '/sim/deviceIndex',
    name: 'SIM',
    children: [
      {
        name: 'deviceMagt',
        path: 'deviceIndex',
        component: () => import('@/views/sim/device/deviceMagtIndex'),
        meta: { title: 'deviceMagt', icon: 'el-icon-folder', noCache: true }
      },
      {
        name: 'orderMagt',
        path: 'orderIndex',
        component: () => import('@/views/sim/order/orderMagtIndex'),
        meta: { title: 'orderMagt', icon: 'el-icon-folder', noCache: true }
      },
      {
        name: 'simMagt',
        path: 'simIndex',
        component: () => import('@/views/sim/sim/simIndex'),
        meta: { title: 'simMagt', icon: 'el-icon-folder', noCache: true }
      },
      {
        name: 'serviceMagt',
        path: 'serviceIndex',
        component: () => import('@/views/sim/service/serviceIndex'),
        meta: { title: 'serviceMagt', icon: 'el-icon-folder', noCache: true }
      },
      {
        name: 'APN',
        path: 'apnIndex',
        component: () => import('@/views/sim/apnIndex'),
        meta: { title: 'APN', icon: 'el-icon-folder', noCache: true }
      }, {
        name: 'simDetail',
        path: 'simDetail',
        component: () => import('@/views/sim/sim/simDetail'),
        meta: { title: 'DETAIL', icon: 'sell', affix: true },
        hidden: true
      }, {
        name: 'deviceDetail',
        path: 'deviceDetail',
        component: () => import('@/views/sim/device/deviceMagtDetail'),
        meta: { title: 'DETAIL', icon: 'el-icon-s-order', noCache: true }
      }, {
        name: 'orderDetail',
        path: 'orderDetail',
        component: () => import('@/views/sim/order/orderMagtDetail'),
        meta: { title: 'DETAIL', icon: 'el-icon-s-order', noCache: true }
      }]
  },
  // 报表--详情页
  {
    path: '/report',
    component: () => import('@/views/report'),
    redirect: '/report/reportIndex',
    name: 'REPORT',
    children: [
      {
        name: 'report',
        path: 'reportIndex',
        component: () => import('@/views/report/reportIndex'),
        meta: { title: '', icon: 'el-icon-s-data', noCache: true }
      }, 
      // {
      //   name: 'reportYhubDetail', // 作废
      //   path: 'reportYhubDetail',
      //   component: () => import('@/views/report/reportYhubDetail'),
      //   meta: { title: 'DETAIL', icon: 'sell', affix: true },
      //   hidden: true
      // }, 
      // {
      //   name: 'lithiumChartPage', // 作废
      //   path: 'lithiumChartPage',
      //   component: () => import('@/views/report/lithiumChartPage'),
      //   meta: { title: 'DETAIL', icon: 'sell', affix: true },
      //   hidden: true
      // }, 
      {
        name: 'reportDetail',
        path: 'reportDetail',
        component: () => import('@/views/report/reportDetailNew'),
        meta: { title: 'DETAIL', icon: 'sell', affix: true },
        hidden: true
      }]
  },
  {
    path: '/QR',
    component: () => import('@/views/QR'),
    redirect: '/QR/models',
    name: 'PRODUCT',
    children: [{
      path: 'models',
      component: () => import('@/views/QR/models'),
      meta: { title: 'MODEL', icon: 'el-icon-s-grid', noCache: true }
    },
    {
      path: 'chargerReportIndex',
      component: () => import('@/views/QR/chargerReportIndex'),
      name: 'chargerReportIndex',
      meta: { title: 'CHARGER_QRDATA', noCache: true }
    },
    {
      path: 'lithiumData',
      component: () => import('@/views/QR/lithiumData'),
      name: 'chargerReportIndex',
      meta: { title: 'LITHIUM_QRDATA', noCache: true }
    },
    {
      path: 'bp',
      component: () => import('@/views/QR/bp'),
      meta: { title: 'BP', noCache: true, keepAlive: true }
    },
    {
      path: 'charges',
      component: () => import('@/views/QR/charges'),
      name: 'charges',
      meta: { title: 'CHARGELOG', noCache: true, keepAlive: true }
    },
    {
      path: 'b',
      component: () => import('@/views/QR/roleMag'),
      name: 'b',
      meta: { title: 'ROLEMANAGEMENT', icon: 'dashboard', noCache: true }
    },
    {

      path: 'workOrder',
      component: () => import('@/views/workOrder/index'),
      name: 'workOrderIndex',
      meta: { title: 'workOrder', icon: 'el-icon-s-grid', noCache: true }
    }, {
      name: 'chargerReportDetail',
      path: 'chargerReportDetail',
      component: () => import('@/views/QR/chargerReportDetail'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true }
    }]
  },
  {
    path: '/blueTooth',
    component: () => import('@/views/blueTooth'),
    name: 'blueTooth',
    redirect: '/blueTooth/btChargeData',
    children: [{
      path: 'btChargeData',
      component: () => import('@/views/blueTooth/chargeData/btChargeData'),
      name: 'btChargeData',
      meta: { title: 'btChargeData', icon: 'el-icon-s-grid', noCache: true },
      hidden: false
    },
    {
      path: 'btYhubData',
      component: () => import('@/views/blueTooth/yhubData/btYhubData'),
      name: 'btYhubData',
      meta: { title: 'btYhubData', icon: 'el-icon-s-grid', noCache: true },
      hidden: false
    },
    {
      path: 'btLiBatteryIndex',
      component: () => import('@/views/blueTooth/liBatteryData/liBatteryIndex'),
      name: 'btLiBatteryIndex',
      meta: { title: 'btLiBatteryIndex', icon: 'el-icon-s-grid', noCache: true },
      hidden: false
    },
    {
      path: 'btLiBatteryData',
      component: () => import('@/views/blueTooth/liBatteryData/liBatteryData'),
      name: 'btLiBatteryData',
      meta: { title: 'btLiBatteryData', icon: 'el-icon-s-grid', noCache: true },
      hidden: false
    },
    {
      path: 'fwUpdateNotice',
      component: () => import('@/views/blueTooth/fwUpdateNotice'),
      name: 'fwUpdateNotice',
      meta: { title: 'fwUpdateNotice', noCache: true },
      hidden: false
    }, {
      name: 'chargeDataDetail',
      path: 'chargeDataDetail',
      component: () => import('@/views/blueTooth/chargeData/btChargeDataDetail'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true },
      hidden: true
    }, {
      name: 'yhubDataDetail',
      path: 'yhubDataDetail',
      component: () => import('@/views/blueTooth/yhubData/btYhubDataDetail'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true },
      hidden: true
    }, {
      name: 'liBatteryIndex',
      path: 'liBatteryIndex',
      component: () => import('@/views/blueTooth/liBatteryData/liBatteryIndex'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true },
      hidden: true
    }, {
      name: 'liBatteryData',
      path: 'liBatteryData',
      component: () => import('@/views/blueTooth/liBatteryData/liBatteryData'),
      meta: { title: 'DETAIL', icon: 'sell', affix: true },
      hidden: true
    }]
  },
  // 意见反馈
  {
    name: 'FEEDBACK',
    path: '/feedBack',
    component: () => import('@/views/feedBack'),
    redirect: '/feedBack/feedBackIndex',
    children: [{
      path: 'feedBackIndex',
      component: () => import('@/views/feedBack/feedBackIndex'),
      meta: { title: '', icon: 'el-icon-s-order', noCache: true }
    }, {
      path: 'feedBackDetail',
      component: () => import('@/views/feedBack/feedBackDetail'),
      meta: { title: 'DETAIL', icon: 'dashboard', noCache: true }
    }]
  },
  // 警告配置
  {
    path: '/warning',
    component: () => import('@/views/warning'),
    redirect: '/warning/warningIndex',
    name: 'WARNING',
    children: [
      {
        name: 'warning',
        path: 'warningIndex',
        component: () => import('@/views/warning/warningIndex'),
        meta: { title: '', icon: 'el-icon-warning', noCache: true, keepAlive: true }

      }, {
        path: 'warningSet',
        component: () => import('@/views/warning/warningSet'),
        meta: { title: 'SETTING', icon: 'warning', noCache: true }
      }],
    hidden: false
  },
  // 设置
  {
    path: '/setting',
    component: () => import('@/views/setting'),
    redirect: '/setting/menuSetting',
    name: 'SETTING',
    children: [
      {
        path: 'menuSetting',
        component: () => import('@/views/setting/menuSetting'),
        meta: { title: 'MENUSETTING', icon: 'el-icon-s-tools', noCache: true }
      },
      {
        path: 'roleSetting',
        component: () => import('@/views/setting/roleSetting'),
        name: 'roleSetting',
        meta: { title: 'ROLEMANAGEMENT', noCache: true }
      },
      {
        path: 'companyIndex',
        component: () => import('@/views/setting/company/companyIndex'),
        name: 'companyIndex',
        meta: { title: 'COMPANY', noCache: true }
      },
      // {
      //   path: 'companyUser',
      //   component: () => import('@/views/setting/company/companyUser'),
      //   name: 'companyUser',
      //   hidden: true,
      //   meta: { title: 'companyUser', noCache: true }
      // },
      // {
      //   path: 'childCompany',
      //   component: () => import('@/views/setting/company/companyChild'),
      //   name: 'childCompany',
      //   hidden: true,
      //   meta: { title: 'childCompany', noCache: true }
      // },
      {
        path: 'fwUpdateIndex',
        component: () => import('@/views/setting/firmwareUpdate/fwUpdateIndex'),
        name: 'fwUpdateIndex',
        meta: { title: 'FWUPDATE', noCache: true, keepAlive: true }
      },
      {
        path: 'fwUpload',
        component: () => import('@/views/setting/firmwareUpdate/fwUpload'),
        name: 'fwUpload',
        meta: { title: 'FWUPLOAD', noCache: true }
      },
      {
        path: 'batteryIndex',
        component: () => import('@/views/setting/battery/batteryIndex'),
        name: 'battery',
        meta: { title: 'BATTERY', noCache: true }
      },
      {
        path: 'curveIndex',
        component: () => import('@/views/setting/curve/curveIndex'),
        name: 'curve',
        meta: { title: 'CURVE', noCache: true }
      },
      {
        path: 'i18nIndex',
        component: () => import('@/views/setting/i18n/i18nIndex'),
        name: 'i18nIndex',
        meta: { title: 'i18n', noCache: true }
      },
      {
        path: 'companyUser',
        component: () => import('@/views/setting/company/companyUser'),
        name: 'companyUser',
        hidden: true,
        meta: { title: 'companyUser', noCache: true }
      },
      {
        path: 'childCompany',
        component: () => import('@/views/setting/company/childCompany'),
        name: 'childCompany',
        hidden: true,
        meta: { title: 'childCompany', noCache: true }
      },
      {
        path: 'fwUpdateDetail',
        component: () => import('@/views/setting/firmwareUpdate/fwUpdateDetail'),
        name: 'fwUpdateDetail',
        hidden: true,
        meta: { title: 'DETAIL', noCache: true }
      },
      {
        path: 'curveDetail',
        component: () => import('@/views/setting/curve/curveDetail'),
        name: 'curveDetail',
        meta: { title: 'DETAIL', noCache: true }
      },
      {
        path: 'testDeviceDetail',
        component: () => import('@/views/testDevice/testDeviceDetail'),
        name: 'testDeviceDetail',
        hidden: true,
        meta: { title: 'DETAIL', noCache: true }
      }
    ]
  },
  // app升级通知
  {
    path: '/appUpdate',
    component: () => import('@/views/appUpdate/appUpdateIndex'),
    meta: { title: 'appUpdateIndex', icon: 'el-icon-coordinate' }
  },
  // 帮助手册
  {
    name: 'doc',
    path: '/doc',
    component: () => import('@/views/doc/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/doc/docList'),
        meta: { title: '', noCache: true }
      },
      {
        path: 'save',
        component: () => import('@/views/doc/docSave'),
        meta: { title: 'docSave', noCache: true }
      }
    ]
  },
  // 计划管理--生产计划
  {
    name: 'planManage',
    path: '/planManage',
    component: () => import('@/views/planManage'),
  },
  // 智能问答
  {
    path: '/smartQa',
    component: () => import('@/views/smartQa'),
    meta: { title: 'smartQa', noCache: true }
  },
  // {
  //   path: '*',
  //   redirect: '/404'
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes

})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// router.beforeEach((to, from, next) => {
//   console.log('to:', to.path)
//   if (to.path == '/404' || to.path == '/dashboard' || to.path == '/login') {
//     next()
//     return
//   }
  
//   console.log('menus:', store.state.menus)
//   const arr = to.path.split('/')
//   console.log(arr)
//   const menus = store.state.menus || []
//   if (menus.length) {
//     const obj = menus.find(item => {
//       const aa = item.menuUrl.split('/')
//       return arr[1] == aa[1]
//     })
//     console.log(obj)
//     if (obj) {
//       console.log('有权限访问')
//       next()
//     }else {
//       next(false)
//     }
//   }
// })

export default router
